import React from 'react';
import Tooltip from './Tooltip';

/**
 * Information icon with tooltip for form field hints
 * @param {Object} props
 * @param {string} props.hint - The tooltip content
 * @param {string} props.position - Position of tooltip (top, right, bottom, left)
 * @param {string} props.width - Width of the tooltip
 */
const InfoIcon = ({ hint, position = 'top', width = 'md' }) => {
  return (
    <Tooltip content={hint} position={position} width={width}>
      <span className="ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 20 20" 
          fill="currentColor" 
          className="w-3 h-3"
          aria-hidden="true"
        >
          <path 
            fillRule="evenodd" 
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" 
            clipRule="evenodd" 
          />
        </svg>
        <span className="sr-only">More information</span>
      </span>
    </Tooltip>
  );
};

export default InfoIcon; 